export default "__VITE_ASSET__f2beb1b8__"